angular.module('ngApp')
.controller('modalController', ['$rootScope', function ($rootScope) {
  this.closeModal = function () {
    $rootScope.modal = false
  }
}])
